import React from "react";
import { EditStudent } from "./student";

const EditBasicDataAdmin = ({ match }) => {
  console.log("Match: ", match);
  return <EditStudent studentEmail={match.params.email} />;
};

export default EditBasicDataAdmin;
